// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4933) return "static/chunks/4933-0d80e193bb9308d3.js";
	if (chunkId === 4659) return "static/chunks/4659-749ca97589acdbf7.js";
	if (chunkId === 4085) return "static/chunks/4085-83ceb27d26abc57b.js";
	if (chunkId === 9073) return "static/chunks/9073-0e1fd04a1761f4a3.js";
	if (chunkId === 1719) return "static/chunks/1719-9dc459df976a580f.js";
	if (chunkId === 8880) return "static/chunks/8880-853923604f19c41e.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2715 ? "41795280" : chunkId) + "." + {"11":"2b7e27cffc56cb00","1220":"69df5457ba8e3020","1721":"6f4ed6db36c6c46f","2635":"588b0c8392487cf0","2715":"1f3810bef05f2e6d","2835":"47083ea4553e8a10","5404":"913c2d3aa1bd43dc","6767":"3ffe8d847806cd74","7392":"02471ba0df7b3ce4","9024":"18cd258e86ed2eea","9438":"49216f83447268f7"}[chunkId] + ".js";
};